// extracted by mini-css-extract-plugin
module.exports = {"planTitle":"PlanTitleSubtitle_planTitle__1cNmb","planSubtitle":"PlanTitleSubtitle_planSubtitle__2bLfE"};